import React, { Component } from 'react';
import Layout from 'COMPONENT/layout';

class FourZeroFour extends Component {
  render() {
    return (
      <Layout
        backTo={() => {
          window.history.go(-1);
        }}
        isShowFooter={false}
        title="H5钱包"
      >
        <div className="not-find">
          <div />
          <p>页面加载失败</p>
        </div>
      </Layout>
    );
  }
}

export default FourZeroFour;



// WEBPACK FOOTER //
// ./src/view/404.js